import React from 'react';
import TicketActivityItem, {
  ITicketingSystemTicketActivityItemProps
} from '../TicketActivityItem/TicketActivityItem';
import './TicketWorkLog.scss';
import {useTranslation} from 'react-i18next';

interface ITicketWorkLogProps {
  selectedDataList: {
    data: any[];
    isLoading: boolean;
  };
  renderTicketActivityItemContent?: ITicketingSystemTicketActivityItemProps['renderTicketActivityItemContent'];
}
const TicketWorkLog = (props: ITicketWorkLogProps): JSX.Element => {
  const {selectedDataList, renderTicketActivityItemContent} = props;
  const {t} = useTranslation();
  return (
    <section className="ticketing-system-ticket-work-log-wrapper">
      <div className="work-log-list-wrapper">
        {selectedDataList?.data?.length > 0 ? (
          selectedDataList.data?.map((logItem: any, idx: number) => (
            <TicketActivityItem
              renderTicketActivityItemContent={renderTicketActivityItemContent}
              key={idx}
              item={logItem}
            />
          ))
        ) : (
          <div className="no-logs-label-wrapper">
            {t('TICKETING_SYSTEM.ACTIVITY.NO_WORK_LOG_LABEL')}
          </div>
        )}
      </div>
    </section>
  );
};
export default TicketWorkLog;
